import Vue from "vue"
import moment from "moment-timezone";

Vue.filter("timeTo", (date) => {
    let seconds = Math.floor((moment(date).seconds() - moment().seconds() / 1000));
    let interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + " years left";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months left";
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days left";
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours left";
    }
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " minutes left";
    }
    return Math.floor(seconds) + " seconds left";
})
